import styled from '@emotion/styled';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Image from '@base/Image';
import H3 from '@base/H3/H3';
import H6 from '@base/H6/H6';
import P1 from '@base/P1/P1';

const Wrapper = styled.div`
  max-width: min-content;
  ${mediaQuery.uptoTablet} {
    margin-bottom: ${Spacings.SPACING_25B};
    max-width: 100%;
  }
`;

const Heading = styled(H3)`
  max-width: 80%;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 422px;
  height: 237px;
  margin: ${Spacings.SPACING_8B} 0 ${Spacings.SPACING_6B};
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 0 auto;
  }
`;

const HR = styled.hr`
  background-color: var(--color-divider);
  height: 1px;
  border: none;
  margin-bottom: ${Spacings.SPACING_6B};
`;

const SubHeading = styled(H6)`
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
  margin-bottom: ${Spacings.SPACING_5B};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.SMALL};
  }
`;

const OfferingWrapper = styled.div`
  display: flex;
  align-items: start;
  margin-bottom: ${Spacings.SPACING_3B};
  img {
    padding-top: ${Spacings.SPACING_2} !important;
  }
`;

const OfferingText = styled(P1)`
  font-weight: ${Fonts.SEMIBOLD};
  padding-left: ${Spacings.SPACING_2B};
  max-width: 50%;
`;

const StaticInfo = ({ cmsData }) => {
  if (!cmsData) return null;
  const {
    selectionPage: { heading, image, offerings, offeringsHeading } = {}
  } = cmsData;

  return (
    <Wrapper>
      <Heading>{heading}</Heading>
      <ImageWrapper>
        <Image src={image} alt="offline-centre" layout="fill" />
      </ImageWrapper>
      <HR />
      <SubHeading>{offeringsHeading}</SubHeading>
      {offerings?.map((offering, index) => (
        <OfferingWrapper key={String(index)}>
          <Image
            src="offline-centres/bullet-checkbox.svg"
            width={20}
            height={20}
            alt="check rounded"
          />
          <OfferingText>{offering}</OfferingText>
        </OfferingWrapper>
      ))}
    </Wrapper>
  );
};

export default StaticInfo;
